import { Box, forwardRef, StyleProps } from '@bonusly/design-system';

interface SelectorOptionProps extends StyleProps {
	isSelected?: boolean;
}

export const SelectorOption = forwardRef(({ isSelected = false, ...rest }: SelectorOptionProps, ref) => {
	return (
		<Box
			_focus={{ backgroundColor: 'gray.25' }}
			_hover={{ backgroundColor: 'gray.50' }}
			as="button"
			backgroundColor="white"
			border={0}
			borderColor="gray.50"
			borderRadius="sm"
			borderStyle="solid"
			cursor="pointer"
			listStyleType="none"
			p={2}
			ref={ref}
			role="option"
			tabIndex={0}
			transitionDuration="normal"
			transitionProperty="common"
			w="full"
			{...(isSelected && {
				'data-focus': true,
			})}
			{...rest}
		/>
	);
});
